import { render, staticRenderFns } from "./crxView.vue?vue&type=template&id=44fe4e35&scoped=true"
var script = {}
import style0 from "./crxView.vue?vue&type=style&index=0&id=44fe4e35&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fe4e35",
  null
  
)

export default component.exports